import {Component, forwardRef} from '@angular/core';
import {FormBuilder, FormsModule, NG_VALUE_ACCESSOR, ReactiveFormsModule} from '@angular/forms';
import {Observable} from 'rxjs';
import {CommonModule} from '@angular/common';
import {MatAutocompleteModule} from '@angular/material/autocomplete';
import {MatFormFieldModule} from '@angular/material/form-field';
import {MatIconModule} from '@angular/material/icon';
import {MatInputModule} from '@angular/material/input';
import {MatSelectModule} from '@angular/material/select';
import {InputAutocompleteComponent} from '../input-autocomplete/input-autocomplete.component';
import {TranslocoDirective} from '@jsverse/transloco';
import {UsState} from '../../../services/model';
import {UsStateService} from '../../../services/us-state.service';

@Component({
  selector: 'app-us-state-autocomplete',
  templateUrl: '../input-autocomplete/input-autocomplete.component.html',
  styleUrls: ['../input-autocomplete/input-autocomplete.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => UsStateAutocompleteComponent),
      multi: true
    }
  ],
  standalone: true,
  imports: [CommonModule, MatAutocompleteModule, ReactiveFormsModule, MatFormFieldModule,
    MatIconModule, TranslocoDirective, MatInputModule, MatSelectModule, MatSelectModule, MatIconModule, FormsModule]
})
export class UsStateAutocompleteComponent extends InputAutocompleteComponent<UsState> {

  constructor(fb: FormBuilder, private usStateService: UsStateService) {
    super(fb);
  }

  override getPlaceholder(): string {
    return 'autocomplete.usStates.placeholder';
  }

  override getData(text: string): Observable<UsState[]> {
    return this.usStateService.getAll(text);
  }

  override getDisplayFn(): (usState: UsState) => string {
    return (usState: UsState): string => {
      return usState?.name || '';
    }
  }
}
